export default __webpack_public_path__ + "static/media/Alexandrine Parakeet.89912472.jpg";